import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { Pagination as AntdPagination, Select, Typography } from "antd";

const propTypes = {
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    setPageSize: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    pageSizeOptions: PropTypes.array,
    hidePageSize: PropTypes.bool,
    hidePageSizeOption: PropTypes.bool,
    hidePagination: PropTypes.bool,
};

const Pagination = ({
    pageSize,
    page,
    total,
    setPageSize,
    setPage,
    pageSizeOptions = [5, 10, 20, 50, 100, 200],
    hidePageSize = false,
    hidePageSizeOption = false,
    hidePagination = false,
}) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            {!hidePageSize ? (
                <div className="page-size">
                    {!hidePageSizeOption && (
                        <Select
                            className="mr-3"
                            value={pageSize}
                            style={{ width: "70px" }}
                            onChange={setPageSize}
                            options={pageSizeOptions.map((i) => ({ value: i, label: i }))}
                        />
                    )}
                    <Typography.Text>
                        {t("paginationDescription", {
                            fromNumber: total ? pageSize * (page - 1) + 1 : 0,
                            toNumber: pageSize * page > total ? total : pageSize * page,
                            totalNumber: total,
                        })}
                    </Typography.Text>
                </div>
            ) : (
                <div />
            )}
            <div className="pagination-box">
                {!hidePagination && (
                    <AntdPagination
                        total={total}
                        pageSize={pageSize}
                        current={page}
                        showSizeChanger={false}
                        onChange={setPage}
                    />
                )}
            </div>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .page-size-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pagination-box {
        .ant-pagination-item-link {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;

Pagination.propTypes = propTypes;

export default Pagination;
